import React from "react";
import { useParams } from "react-router-dom";
import Container from "../../components/Container/Container";
import { ROUTER } from "../../constants/env";
import CarnetS from "../../components/Carnet/CarnetS";

const CarnetStudent = () => {
  const { id } = useParams();
  const tris = localStorage.getItem("tris");
  const number = { premier: 1, deuxieme: 2, troisieme: 3 }[tris];
  const trisTitle = number ? `| Trimestre : ${number}` : "";
  return (
    <Container
      name={`Carnet de Note ${trisTitle}`}
      back={true}
      backRoute={ROUTER.CARNETS.LIST}
    >
      <CarnetS key={id} />
    </Container>
  );
};

export default CarnetStudent;
